<div>
  <new-sign-up-card
    class="sign-up-card"
    [showSignIn]="true"
    (signIn)="signIn()"
    (confirmAccount)="confirmAccount($event)"
    (forgotPassword)="forgotPassword($event)"
  ></new-sign-up-card>
</div>
